import React from "react";
import Tick1 from "../../../assets/icons/tick1.png";
import Tick2 from "../../../assets/icons/tick2.png";
import clock from "../../../assets/icons/clock.png";

//INCRESE THIS NUMBER TO ACTIVE ROADMAP PHASES
const currentStage = 0;

const Roadmap = () => {
  const stages = [
    {
      title: "STAGE 1",
      datalist: [
        {
          title: "Grow farm to 1000K BUSD",
          desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sit eget iaculis turpis at amet eu.",
        },
        {
          title: "Grow farm to 1000K BUSD",
          desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sit eget iaculis turpis at amet eu.",
        },
      ],
    },
    {
      title: "STAGE 2",
      datalist: [
        {
          title: "Grow farm to 1000K BUSD",
          desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sit eget iaculis turpis at amet eu.",
        },
      ],
    },
    {
      title: "STAGE 3",
      datalist: [
        {
          title: "Stay Tuned for More !",
          desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sit eget iaculis turpis at amet eu.",
        },
      ],
    },
  ];

  return (
    <section className=" py-20">
      <div className="container">
        <h2 className="text-center text-[30px] md:text-[44px] font-semibold">
          D3 Roadmap
        </h2>
        <p className="text-gray mx-auto max-w-md text-base md:text-lg mt-3 text-center ">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis sed ut
          convallis consequat nunc leo laoreet.
        </p>

        <div className=" grid gap-20 mt-20 relative">
          <div className="h-full w-[2px]  border-[#262626]  border-dashed border-r-2 absolute left-1/2  "></div>
          {stages.map((val, i) => (
            <div key={i} className="relative ">
              <div
                className={` ${
                  currentStage >= i
                    ? "bg-primary text-dark-400 border border-primary"
                    : " bg-[#262626] text-gray font-medium border border-[#4E4E4E]"
                }  max-w-max  p-2.5 px-5  rounded-full mb-8 grid grid-flow-col gap-2 items-center justify-center  text-base  font-medium  mx-auto`}
              >
                <img
                  src={currentStage >= i ? Tick1 : clock}
                  alt=""
                  className="w-6"
                />
                <p>{val.title}</p>
              </div>
              <div className="max-w-[450px] grid gap-6 mx-auto">
                {val.datalist.map((value, ind) => (
                  <div className=" bg-[#161616] py-4 px-3 rounded-xl " key={i}>
                    <div className="grid grid-flow-col gap-2 justify-center items-center">
                      {currentStage >= i && (
                        <img src={Tick2} alt="" className="w-7" />
                      )}
                      <p>{value.title}</p>
                    </div>
                    <p className="max-w-sm mx-auto text-center mt-3 text-gray">
                      {value.desc}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
